import { Tooltip } from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IEmpresa, IResultadoItem, IResultadoItemNFSE } from "../../../model";
import { MDBBtn, } from "mdbreact";
import * as moment from "moment";
import { AppStore } from "../../../stores/AppStore";
import { ResultadoStore } from "../../../stores/resultados/ResultadoStore";
import { NotaItemDialog } from "./item-detail/ItemDialogNota";
import { columns_nfse } from "../../utils/TableDetalhamento"
import BootstrapTable from 'react-bootstrap-table-next';
import { NfseItemDialog } from "./item-detail/ItemDialogNFSE";
const numeral = require("numeral");

interface Props {
  items: any[]
  modelo: string
  data: any
  entrada_saida: string
}

@observer
export class DetalhamentoNfseTable extends React.Component<Props, {}> {

  obs = observable({
    new_columns_nfse: columns_nfse,
    viewing: null as IResultadoItem
  })

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let temp_table: any = [];
    ResultadoStore.handldeItensProcessando();

    temp_table = [
      {
        dataField: 'acoes',
        text: 'Ações',
        formatter: (cell, row) => {
          return (this.buttonFormatterContestar(cell, row))
        },
      }
    ]

    this.obs.new_columns_nfse = columns_nfse.concat(temp_table)
  }

  handleContest(item: IResultadoItem) {
    this.onSelect(item, true)
    ResultadoStore.obs.openContestacaoLote = true;
  }

  handleView(item: IResultadoItem) {
    this.obs.viewing = item;
  }

  handleViewClose = () => {
    this.obs.viewing = null;
  };

  onSelectAll = async (isSelect, rows) => {
    if (isSelect) {
      let data = rows?.map(value => {
        return {
          id: value.id,
          data: value.data
        }
      })
      ResultadoStore.setContestarItemsList(data);
    } else {
      ResultadoStore.resetContestarItems();
    }
  };

  onSelect = async (item, checked) => {
    let data = {
      id: item.id,
      data: item.data
    }
    if (checked) {
      ResultadoStore.setContestarItems(data);
    } else {
      ResultadoStore.deleteByIdContestarItems(item.id);
    }
  }

  handleRemoverSelecionadosAll() {
    // ResultadoStore.clearSelection();
    ResultadoStore.obs.contestar_todos = false;
  }

  renderViewDialog() {
    return (
      <NfseItemDialog
        modelo={this.props.modelo}
        item={this.obs.viewing}
        data={this.props.data}
        onClose={this.handleViewClose}
        entrada_saida={this.props.entrada_saida}
      />
    );
  }

  renderShowsTotal(start, to, total) {
    return (
      <p style={{ marginLeft: 12 }}>
        Mostrando {start} a {to} de {total} resultados.&nbsp;&nbsp;
      </p>
    );
  }

  buttonFormatterContestar = (cell, row) => {

    let niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];

    let isDisabled = niveis_acesso.indexOf("c2") == -1

    if (AppStore.obs1.usuario) {

      if (ResultadoStore.obs.itens_processando.indexOf(row.id) != -1) {

        return (
          <>
            <div style={{ display: "flex" }}>
              <MDBBtn rounded size="sm" onClick={() => this.handleView(row.item)}>
                <img src="/images/contestar.svg" width={20} />
              </MDBBtn>

              <MDBBtn rounded size="sm">
                <Tooltip content={"Processando"}>
                  <img src="/images/icone-relogio.png" width={25} />
                </Tooltip>
              </MDBBtn>

            </div>

          </>
        )
      }

      return (
        <>
          <div style={{ display: "flex" }}>

            <MDBBtn rounded size="sm" onClick={() => this.handleView(row.item)}>
              <img src="/images/contestar.svg" width={20} />
            </MDBBtn>

            <MDBBtn rounded size="sm" onClick={() => this.handleContest(row.item)} disabled={isDisabled}>
              <Tooltip content={row.item.contestacao_calc_id ? "Item contestado" : "Contestar"}>
                {row.item.contestacao_calc_id
                  ? <img src="/images/contestado.png" width={20} />
                  : <img src="/images/contestar.png" width={20} />}
              </Tooltip>
            </MDBBtn>

          </div>

        </>

      );

    }

  };

  handleTrClassFormat(row, rowIndex) {

    if (row.competencia) {

      let competencia = moment(row.competencia).format("MM/YYYY")

      let data_calculo = moment(row.data_calculo).format("MM/YYYY")

      if (competencia != data_calculo) {

        return "item-sem-icms-st";

      }

    }

    return "";

  }

  public render() {
    const items_new = this.props.items?.map((item: IResultadoItemNFSE) => {

      return (
        {
          id: item._id,
          conta_id: item.conta_id,
          data: item.data,
          data_calculo: item.data_calculo,
          competencia: item.competencia,
          nnfe: item.nnfe,
          chave: item.chave,
          descricao: item.descricao,
          item_lista_servico: item.cod_trib_nacional,
          valor: numeral(item.valor).format("$ 0,0.00"),
          valor_deducoes: numeral(item.valor_deducoes).format("$ 0,0.00"),
          valor_pis: numeral(item.valor_pis).format("$ 0,0.00"),
          valor_cofins: numeral(item.valor_cofins).format("$ 0,0.00"),
          valor_iss: numeral(item.valor_iss).format("$ 0,0.00"),
          valor_ir: numeral(item.valor_ir).format("$ 0,0.00"),
          valor_csll: numeral(item.valor_csll).format("$ 0,0.00"),
          valor_inss: numeral(item.valor_inss).format("$ 0,0.00"),
          item: item
        }
      );
    });

    const selectRowProp = {
      mode: 'checkbox',
      clickToSelect: false,
      style: { backgroundColor: '#e9f6ff' },
      onSelectAll: this.onSelectAll,
      selected: ResultadoStore.obs.contestarItems?.map(value => value.id),
      onSelect: this.onSelect,
      nonSelectable: ResultadoStore.obs.itens_processando,
    };

    return (
      <>

        <div>

          {/* @ts-ignore */}
          <BootstrapTable keyField="id" className="TableDefault" data={items_new} columns={this.obs.new_columns_nfse} selectRow={selectRowProp} rowClasses={this.handleTrClassFormat} hover />

        </div>

        {this.obs.viewing && this.renderViewDialog()}
      </>
    );
  }
}

export default DetalhamentoNfseTable;
